import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = 'website',
  image = '/logo.png'
}) => {
  const siteTitle = 'BalanzFit';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Vind jouw balans in fitness en voeding`;
  const baseUrl = 'https://www.balanzfit.com';
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const imageSrc = typeof image === 'string' && image.length ? image : '/logo.png';
  const fullImage = typeof imageSrc === 'string' && imageSrc.startsWith('http') ? imageSrc : `${baseUrl}${imageSrc}`;
  
  const defaultDescription = 'BalanzFit - Jouw persoonlijke partner voor een gezonder en fitter leven. Track voeding, plan workouts en bereik je doelen.';
  const metaDescription = description || defaultDescription;

  return (
    <Helmet>
      {/* Basis meta tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="nl_NL" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
};

export default SEO;

